import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useTranslation} from "react-i18next";
import {useRef, useState} from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import Form from "react-bootstrap/Form";
import axiApi from "ApiCaller";
import {SwalAlertClass} from "core/swalClass";
import FormButton from "components/buttons/FormButton";

const FormTasks = ({item, setItem, setShowCanvas, showCanvas, fetchTasks, leaderOptions = []}) => {
    const {t: _Tf} = useTranslation("forms");
    const {t: _Tr} = useTranslation("routes");
    const {t: _Td} = useTranslation("datestimes");
    const {t: _Tt} = useTranslation("tables");

    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});
    const [isLoading, setIsLoading] = useState(false);
    const inputRefs = useRef({name: null});


    const handleClose = () => setShowCanvas(false);

    const handleChange = (e) => {
        const {name, type} = e.target;
        const value = type === "checkbox" ? e.target.checked : e.target.value;
        let item_ = {...item};
        item_[name] = value;
        setItem(item_);
    };

    
    const handleSubmit = () => {
        if (!item || !item.name) {
            Alert.warning("Falta dato obligatorio", "Es necesario un Nombre").then(() => {
                inputRefs.current.name && inputRefs.current.name.focus();
            });
            return;
        }
        setIsLoading(true);

        const payload = {
            id: item.id || null,
            name: item.name,
            description: item.description || "",
            type: item.type || "p",
            leader: item.leader_email || "",
        };

        axiApi
            .post("/api/maint/tasks/add/", payload)
            .then((resp) => {
                if (resp.data) {
                    fetchTasks();
                    setShowCanvas(false);
                    Alert.info("Guardado", "Se ha guardado correctamente");
                } else {
                    Alert.error("Error al guardar", resp.data?.message || "Consultar con el administrador");
                }
            })
            .catch((err) => {
                console.error(err);
                Alert.error("Error servidor", "Consultar con el administrador");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <Offcanvas
            show={showCanvas}
            onHide={handleClose}
            placement="end"
            backdrop="static"
            style={{width: "40%", fontSize: "15px"}}>
            <Offcanvas.Header className="preview-canvas">
                <div className="preview-icon">
                    <FontAwesomeIcon icon="wrench" />
                </div>
                <div className="preview-title">
                    <Offcanvas.Title>{_Tr("labels.tasks")}</Offcanvas.Title>
                </div>
            </Offcanvas.Header>
            <Offcanvas.Body className="pt-0" style={{fontSize: "13px"}}>
                <div className="container-fluid">
                    <div className="row g-3 mb-5 pb-5">
                        <div className="col-12">

                            {/* Nombre */}
                            <div className="row g-3 align-items-center">
                                <div className="col-3">
                                    <label className="col-form-label">{_Tf("common.name")} *</label>
                                </div>
                                <div className="col-9">
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="name"
                                        value={item.name || ""}
                                        onChange={handleChange}
                                        ref={(el) => (inputRefs.current.name = el)}
                                    />
                                </div>
                            </div>

                            {/* Descripción */}
                            <div className="row g-3 align-items-center mt-3">
                                <div className="col-3">
                                    <label className="col-form-label">{_Tf("common.description")}</label>
                                </div>
                                <div className="col-9">
                                    <textarea
                                        className="form-control"
                                        rows="3"
                                        name="description"
                                        value={item.description || ""}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            {/* Tipo */}
                            <div className="row g-3 align-items-center mt-3">
                                <div className="col-3">
                                    <label className="col-form-label">{_Tf("common.type")}</label>
                                </div>
                                <div className="col-9">
                                    <Form.Select
                                        name="type"
                                        value={item.type || "p"}
                                        onChange={handleChange}
                                        style={{maxWidth: "160px"}}>
                                        <option value="p">Preventivo</option>
                                        <option value="c">Correctivo</option>
                                    </Form.Select>
                                </div>
                            </div>

                            {/* Líder */}
                            <div className="row g-3 align-items-center mt-3">
                                <div className="col-3">
                                    <label className="col-form-label">{_Tt("tasks.leader")}</label>
                                </div>
                                <div className="col-9">
                                    <Form.Select
                                        name="leader_email"
                                        value={item.leader_email || ""}
                                        onChange={handleChange}>
                                        <option value="">— Sin Encargado —</option>
                                        {leaderOptions.map((opt) => (
                                            <option key={opt.value} value={opt.value}>
                                                {opt.value}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="p-3 buttons-footer">
                    <div className="position-fixed bottom-0 end-0 mb-3 me-5">
                        <button type="button" className="btn btn-secondary" onClick={handleClose}>
                            {_Tf("labels.cancel")}
                        </button>
                        <FormButton
                            label="Guardar"
                            className="btn btn-primary ms-4"
                            isProcessing={isLoading}
                            onClick={handleSubmit}>
                            {_Tf("labels.save")}
                        </FormButton>
                    </div>
                </div>
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default FormTasks;

   